import { GridColDef, GridColumnGroupingModel, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { DAYS_QTR, PAGE_SIZE } from '../../common/constants';
import { formatTo0Decimal, isEmpty, isEmptyArray } from '../../common/util.services';
import { getAdSpendData, getTacosOverall, syncAdSpend} from '../amazon.services';
import { FormControl, FormControlLabel, Grid, IconButton, Radio, RadioGroup, Stack, Tooltip, Typography } from '@mui/material';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import '../amazon.scss';
import IButton from '../../../components/button/i-button.component';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import IReadOnlyField from '../../../components/text-component/readonly-field/i-readonlyfield.component';
import { AssessmentOutlined, PlayCircleOutline } from '@mui/icons-material';
import YesNoDialog from '../../../components/message-dialog/yes-no-dialog.component';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import TotalAdCostTrend from './total-ad-cost-trend.component';
import HourlyAdCostTrend from './hourly-ad-cost-trend.component';

const AmazonTacos = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [adSpendData, setAdSpendData] = useState(rows);
  const [showSyncMsg, setShowSyncMsg] = useState(false);
  dayjs.extend(utc);
  dayjs.extend(timezone);
  let today = dayjs();
  let sDate = today.subtract(DAYS_QTR, 'day');
  const [startDate, setStartDate] = useState<any>(sDate);
  const [endDate, setEndDate] = useState<any>(today);
  const [date, setDate] = useState('');
  const [period, setPeriod] = useState('Daily');
  const [tacosOverall, setTacosOverall] = useState<any>([])
  const [loading, setLoading] = useState(true);
  const [openTotalTrend, setOpenTotalTrend] = useState(false);
  const [openHourlyTrend, setOpenHourlyTrend] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);
  const columns: GridColDef[] = [
    { field: 'period', headerName: 'Period', filterable: false, sortable: false, editable: false, width: 130,
      cellClassName: (params) => { return "Tacos2" }
    },
    { field: 'sync', headerName: 'Sync', filterable: false, sortable: false, editable: false, width: 20,
      renderCell: (params) => (<Stack direction="row" alignItems="center" justifyContent="center" sx={{ height: '100%' }} > 
                               <PlayCircleOutline fontSize='small' color="secondary"/> </Stack>)
    },
    { field: 'adTotal', headerName: 'Ads', width: 65, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'adDiff', headerName: 'Diff', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNameDiff(params.row.adDiff) }
    },
    { field: 'saleTotal', headerName: 'Sale', width: 70, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosTotal', headerName: 'ACOS', width: 70, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%',
      cellClassName: (params) => { return getClassNameAcos(params.row.acosTotal) }
    },
    { field: 'tacosTotal', headerName: 'TACOS', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%',
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosTotal) }
    },
    { field: 'adSalsaNapkin', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleSalsaNapkin', headerName: 'Sale', width: 65, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosSalsaNapkin', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosSalsaNapkin) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosSalsaNapkin', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosSalsaNapkin) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adLaundryBag', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleLaundryBag', headerName: 'Sale', width: 65, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosLaundryBag', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosLaundryBag) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosLaundryBag', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosLaundryBag) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adShoeBag', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleShoeBag', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosShoeBag', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosShoeBag) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosShoeBag', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosShoeBag) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adBsPlacemat', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleBsPlacemat', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosBsPlacemat', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosBsPlacemat) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosBsPlacemat', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosBsPlacemat) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adBsRunner', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleBsRunner', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosBsRunner', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosBsRunner) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosBsRunner', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosBsRunner) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adCanvasTableCloth', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleCanvasTableCloth', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosCanvasTableCloth', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosCanvasTableCloth) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosCanvasTableCloth', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosCanvasTableCloth) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adWineBottleCover', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleWineBottleCover', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosWineBottleCover', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosWineBottleCover) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosWineBottleCover', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosWineBottleCover) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adBsCushionCover', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleBsCushionCover', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosBsCushionCover', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosBsCushionCover) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosBsCushionCover', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosBsCushionCover) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adFoutaTowel', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleFoutaTowel', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosFoutaTowel', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosFoutaTowel) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosFoutaTowel', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosFoutaTowel) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adDobbyNapkin', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleDobbyNapkin', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosDobbyNapkin', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosDobbyNapkin) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosDobbyNapkin', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosDobbyNapkin) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adCanvasCurtain', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleCanvasCurtain', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosCanvasCurtain', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosCanvasCurtain) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosCanvasCurtain', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosCanvasCurtain) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adSlubDuck', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleSlubDuck', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosSlubDuck', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosSlubDuck) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosSlubDuck', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosSlubDuck) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adCottonYogaMat', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleCottonYogaMat', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosCottonYogaMat', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosCottonYogaMat) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosCottonYogaMat', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosCottonYogaMat) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adStrawYogaMat', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleStrawYogaMat', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosStrawYogaMat', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosStrawYogaMat) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosStrawYogaMat', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosStrawYogaMat) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adUtilityBag', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleUtilityBag', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosUtilityBag', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosUtilityBag) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosUtilityBag', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosUtilityBag) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adCheckRunner', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleCheckRunner', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosCheckRunner', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosCheckRunner) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosCheckRunner', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosCheckRunner) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adFlaxNapkin', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleFlaxNapkin', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosFlaxNapkin', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosFlaxNapkin) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosFlaxNapkin', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosFlaxNapkin) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adCushionCover', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleCushionCover', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosCushionCover', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosCushionCover) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosCushionCover', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosCushionCover) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adCheckNapkin', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleCheckNapkin', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosCheckNapkin', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosCheckNapkin) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosCheckNapkin', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosCheckNapkin) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adPlainNapkin', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'salePlainNapkin', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosPlainNapkin', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosPlainNapkin) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosPlainNapkin', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosPlainNapkin) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adKitchenTowel', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleKitchenTowel', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosKitchenTowel', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosKitchenTowel) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosKitchenTowel', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosKitchenTowel) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adStrawMat', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleStrawMat', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosStrawMat', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosStrawMat) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosStrawMat', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosStrawMat) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'adBambooMat', headerName: 'Ads', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'saleBambooMat', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '0' : getValue0Decimal(value)
    },
    { field: 'acosBambooMat', headerName: 'ACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameAcos(params.row.acosBambooMat) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    },
    { field: 'tacosBambooMat', headerName: 'TACOS', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNameTacos(params.row.tacosBambooMat) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? 'NA' : getValue0Decimal(value) + '%'
    }
  ];

  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
  const columnGroupingModel: GridColumnGroupingModel = [
    { groupId: 'Period/Sync', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'period' }, { field: 'sync' }],
      renderHeaderGroup: (params) => (<Stack direction="row" spacing={0} alignItems="center">
                                        <Typography variant="subtitle2" sx={{ marginRight: 1 }}>Ad Cost Trend</Typography>
                                        <Tooltip title={'Total'} PopperProps={popperProps}>
                                        <IconButton size="small" onClick={openTotalCostTrend}>
                                          <AssessmentOutlined fontSize="small" color='primary'/></IconButton></Tooltip>
                                        <Tooltip title={'Hourly'} PopperProps={popperProps}>
                                        <IconButton size="small" onClick={openHourlyCostTrend}>
                                          <AssessmentOutlined fontSize="small" color='primary'/></IconButton></Tooltip>
                                      </Stack>)},
    { groupId: 'Total', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'adTotal' }, { field: 'adDiff' }, { field: 'saleTotal' }, { field: 'tacosTotal' }, { field: 'acosTotal'}, ]},
    { groupId: 'Salsa Napkin', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'adSalsaNapkin' }, { field: 'saleSalsaNapkin' }, { field: 'tacosSalsaNapkin' }, { field: 'acosSalsaNapkin' }, ]},
    { groupId: 'Laundry Bag', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'adLaundryBag' }, { field: 'saleLaundryBag' }, { field: 'tacosLaundryBag' }, { field: 'acosLaundryBag' }]},
    { groupId: 'Shoe Bag', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'adShoeBag' }, { field: 'saleShoeBag' }, { field: 'tacosShoeBag' }, { field: 'acosShoeBag' }]},
    { groupId: 'BS Placemat', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'adBsPlacemat' }, { field: 'saleBsPlacemat' }, { field: 'tacosBsPlacemat' }, { field: 'acosBsPlacemat' }]},
    { groupId: 'BS Runner', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'adBsRunner' }, { field: 'saleBsRunner' }, { field: 'tacosBsRunner' }, { field: 'acosBsRunner' }]},
    { groupId: 'Canvas Table Cloth', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'adCanvasTableCloth' }, { field: 'saleCanvasTableCloth' }, { field: 'tacosCanvasTableCloth' }, { field: 'acosCanvasTableCloth' }]},
    { groupId: 'Wine Bottle Cover', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'adWineBottleCover' }, { field: 'saleWineBottleCover' }, { field: 'tacosWineBottleCover' }, { field: 'acosWineBottleCover' }]},
    { groupId: 'BS Cushion Cover', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'adBsCushionCover' }, { field: 'saleBsCushionCover' }, { field: 'tacosBsCushionCover' }, { field: 'acosBsCushionCover' }]},
    { groupId: 'Fouta Towel', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'adFoutaTowel' }, { field: 'saleFoutaTowel' }, { field: 'tacosFoutaTowel' }, { field: 'acosFoutaTowel' }]},
    { groupId: 'Dobby Napkin', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'adDobbyNapkin' }, { field: 'saleDobbyNapkin' }, { field: 'tacosDobbyNapkin' }, { field: 'acosDobbyNapkin' }]},
    { groupId: 'Canvas Curtain', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'adCanvasCurtain' }, { field: 'saleCanvasCurtain' }, { field: 'tacosCanvasCurtain' }, { field: 'acosCanvasCurtain' }]},
    { groupId: 'Slub Duck', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'adSlubDuck' }, { field: 'saleSlubDuck' }, { field: 'tacosSlubDuck' }, { field: 'acosSlubDuck' }]},
    { groupId: 'Cotton Yoga Mat', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'adCottonYogaMat' }, { field: 'saleCottonYogaMat' }, { field: 'tacosCottonYogaMat' }, { field: 'acosCottonYogaMat' }]},
    { groupId: 'Straw Yoga Mat', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'adStrawYogaMat' }, { field: 'saleStrawYogaMat' }, { field: 'tacosStrawYogaMat' }, { field: 'acosStrawYogaMat' }]},
    { groupId: 'Utility Bag', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'adUtilityBag' }, { field: 'saleUtilityBag' }, { field: 'tacosUtilityBag' }, { field: 'acosUtilityBag' }]},
    { groupId: 'Check Runner', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'adCheckRunner' }, { field: 'saleCheckRunner' }, { field: 'tacosCheckRunner' }, { field: 'acosCheckRunner' }]},
    { groupId: 'Flax Napkin', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'adFlaxNapkin' }, { field: 'saleFlaxNapkin' }, { field: 'tacosFlaxNapkin' }, { field: 'acosFlaxNapkin' }]},
    { groupId: 'Cushion Cover', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'adCushionCover' }, { field: 'saleCushionCover' }, { field: 'tacosCushionCover' }, { field: 'acosCushionCover' }]},
    { groupId: 'Check Napkin', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'adCheckNapkin' }, { field: 'saleCheckNapkin' }, { field: 'tacosCheckNapkin' }, { field: 'acosCheckNapkin' }]},
    { groupId: 'Plain Napkin', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'adPlainNapkin' }, { field: 'salePlainNapkin' }, { field: 'tacosPlainNapkin' }, { field: 'acosPlainNapkin' }]},
    { groupId: 'Kitchen Towel', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'adKitchenTowel' }, { field: 'saleKitchenTowel' }, { field: 'tacosKitchenTowel' }, { field: 'acosKitchenTowel' }]},
    { groupId: 'Straw Mat', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'adStrawMat' }, { field: 'saleStrawMat' }, { field: 'tacosStrawMat' }, { field: 'acosStrawMat' }]},
    { groupId: 'Bamboo Mat', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'adBambooMat' }, { field: 'saleBambooMat' }, { field: 'tacosBambooMat' }, { field: 'acosBambooMat' }]}
  ];

  function getClassNameTacos(value: any) {
    return isEmpty(value) ? '' : value > 20 ? 'PerfNegative' : 'PerfPositive';
  }

  function getClassNameAcos(value: any) {
    return isEmpty(value) ? '' : value > 35 ? 'PerfNegative' : 'PerfPositive';
  }

  function getClassNameDiff(value: any) {
    return isEmpty(value) || (value < 0.05 && value > -0.05) ? '' : value >= 0.05 ? 'AdDiffP' : 'AdDiffN';
  }

  useEffect(() => {
    getTacosData();
    getTacosOverallData();
  }, [period, startDate, endDate, page, pageSize]);

  function getTacosData() {
    if (isEmptyArray(rows)) {
      setLoading(true);
      let data = {startDate, endDate, period};
      getAdSpendData(data, page, pageSize, appContext,
        (response: any) => {
          setAdSpendData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }

  function getTacosOverallData() {
    setLoading(true);
    let dates = {startDate, endDate};
    getTacosOverall(dates, appContext,
      (response: any) => {
        setTacosOverall(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const onCellClick = (value: any) => {
    if('sync' === value.field) {
      if('Daily' === period) {
        setDate(value.row.idDate);
        setShowSyncMsg(true);
      } else {
        appContext.setDialogMessage('Sync is applicable for \'Daily\' mode only.');
      }
    }
  }

  const openTotalCostTrend = () => {
    setOpenTotalTrend(true);
  }

  const closeTotalCostTrend = () => {
    setOpenTotalTrend(false);
  }

  const openHourlyCostTrend = () => {
    setOpenHourlyTrend(true);
  }

  const closeHourlyCostTrend = () => {
    setOpenHourlyTrend(false);
  }

  const onOkClick = () => {
    appContext.setShowLoader(true);
    setLoading(true);
    syncAdSpend(date, appContext,
      (response: any) => {
        getTacosData();
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const getValue0Decimal = (value: any) => {
    return isEmpty(value) ? 'NA' : formatTo0Decimal(Math.round(value * 1));
  }

  const getDecimalPct = (value: any) => {
    return isEmpty(tacosOverall[value]) ? 'NA' : formatTo0Decimal(Math.round(tacosOverall[value] * 100)) + '%';
  }

  const search = (e: any) => {
    getTacosData();
  }

  const startDatechange = (value: any) => {
    setStartDate(value);
  }

  const endDatechange = (value: any) => {
    setEndDate(value);
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPeriod((event.target as HTMLInputElement).value);
  }

  const getMainPanel = () => {
    return <>
      <Grid xs={2} sx={{ pl: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <FormControlLabel control={<LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <DatePicker slotProps={{ textField: { size: 'small' } }} format={'DD/MM/YYYY'}  
                                        label={'Start Date'} value={startDate} onChange={startDatechange} timezone="America/Los_Angeles"/>
                                    </LocalizationProvider>} label='' />
        <FormControlLabel control={<LocalizationProvider dateAdapter={AdapterDayjs}> 
                                      <DatePicker slotProps={{ textField: { size: 'small' } }} format={'DD/MM/YYYY'} 
                                        label={'End Date'} value={endDate} onChange={endDatechange} timezone="America/Los_Angeles"/>
                                    </LocalizationProvider>} label='' />
        <FormControl>
          <RadioGroup defaultValue="Daily" name="period" row={true} onChange={handleChange}>
            <FormControlLabel value="Daily" control={<Radio />} label="Daily" />
            <FormControlLabel value="Weekly" control={<Radio />} label="Weekly" />
            <FormControlLabel value="Monthly" control={<Radio />} label="Monthly" />
          </RadioGroup>
        </FormControl>
        <IButton label='Submit' onActionEvent={search}/>
      </Grid>
      <Grid xs={12} display="flex" justifyContent="center">
        <Grid container columnSpacing={1} rowSpacing={0} sx={{ maxWidth: '1380px', mt: 2, border: '1px solid #D3D3D3', borderRadius: '4px', p: 2}}>
          <Grid xs={2}>
            <IReadOnlyField label='Days' value={tacosOverall.Days}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Total' value={getDecimalPct('Total')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Salsa Napkin' value={getDecimalPct('Salsa Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Laundry Bag' value={getDecimalPct('Laundry Bag')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Shoe Bag' value={getDecimalPct('Shoe Bag')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Slub Duck' value={getDecimalPct('Slub Duck')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Canvas Curtain' value={getDecimalPct('Canvas Curtain')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Cotton Yoga Mat' value={getDecimalPct('Cotton Yoga Mat')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Straw Yoga Mat' value={getDecimalPct('Straw Yoga Mat')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Utility Bag' value={getDecimalPct('Utility Bag')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Fouta Towel' value={getDecimalPct('Fouta Towel')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='BS Runner' value={getDecimalPct('BS Runner')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='BS Placemat' value={getDecimalPct('BS Placemat')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='BS Cushion Cover' value={getDecimalPct('BS Cushion Cover')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Wine Bottle Cover' value={getDecimalPct('Wine Bottle Cover')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Dobby Napkin' value={getDecimalPct('Dobby Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Canvas Table Cloth' value={getDecimalPct('Canvas Table Cloth')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Check Runner' value={getDecimalPct('Check Runner')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Flax Napkin' value={getDecimalPct('Flax Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Cushion Cover' value={getDecimalPct('Cushion Cover')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Check Napkin' value={getDecimalPct('Check Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Plain Napkin' value={getDecimalPct('Plain Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Kitchen Towel' value={getDecimalPct('Kitchen Towel')}/>
          </Grid>
        </Grid>
      </Grid>
      <IGridComponent title={''} rows={adSpendData} columns={columns} loading={loading} maxHeight={450}
          paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
          getRowId={(row: any) => row.idDate} columnGroupingModel={columnGroupingModel} cellClick={onCellClick}
          showAction={false} showApproveAction={false} showDeleteAction={false} showEditAction={false} />
      <YesNoDialog open={showSyncMsg} onClose={() => { setShowSyncMsg(false) }}
                onOk={() => { setShowSyncMsg(false); onOkClick(); }} isHorizontal={true} 
                message={'Do you want to sync the data?'}/>
      <IDialogComponent onClose={closeTotalCostTrend} open={openTotalTrend} title='Total Ad Cost Trend' 
        dialogBody={<TotalAdCostTrend />} />
      <IDialogComponent onClose={closeHourlyCostTrend} open={openHourlyTrend} title='Hourly Ad Cost Trend' 
        dialogBody={<HourlyAdCostTrend />} />
    </>
  }

  return <TitlePanel title={(period.includes('Daily') ? 'Daily' : 
                             period.includes('Weekly') ? 'Weekly' : 'Monthly') + ' Ad Cost'} panelBody={getMainPanel()} />
}

export default AmazonTacos;